import { useDriverActions } from "../actions/driverActions"
import { useDriverBuilders } from "../builders/driverBuilders"
import { useDriverLoaders } from "../loaders/driverLoaders"

export const useDriverService = () => {
    const { buildDriver } = useDriverBuilders()
    
    const driverLoaders = useDriverLoaders()

    const { saveDriver } = useDriverActions()

    const archiveDriver = async (driverId: string) => {
        const { loadDriver } = driverLoaders()
        const driver = await loadDriver(driverId, true)
        const archivedDriver = buildDriver({
            ...driver,
            archived: true
        })
        return saveDriver(archivedDriver)
    }

    return {
        archiveDriver
    }
}
